import { TranslateModule } from '@ngx-translate/core';

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { OverlayModule } from '@angular/cdk/overlay';

import { FcpButtonModule, FcpCheckboxModule, FcpIconModule, FcpTooltipModule } from 'fc-ui-components';

import { PipesModule } from 'pipes';

import { RequestAccessModalComponent } from './request-access-modal.component';
import { ModalModule } from 'components';

@NgModule({
    declarations: [RequestAccessModalComponent],
    imports: [
        CommonModule,
        FormsModule,
        TranslateModule,
        ModalModule,
        FcpButtonModule,
        FcpCheckboxModule,
        FcpIconModule,
        PipesModule,
        FcpTooltipModule,
        OverlayModule
    ],
    exports: [RequestAccessModalComponent]
})
export class RequestAccessModalModule {}
